import { render, staticRenderFns } from "./BlockInfo.vue?vue&type=template&id=7c935c52&scoped=true&"
import script from "./BlockInfo.vue?vue&type=script&lang=js&"
export * from "./BlockInfo.vue?vue&type=script&lang=js&"
import style0 from "./BlockInfo.vue?vue&type=style&index=0&id=7c935c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c935c52",
  null
  
)

export default component.exports